<template>
  <div class="home">
    <!--    <div class="head-box">-->
    <!--      <headPage/>-->
    <!--    </div>-->
    <!--    <div class="bx-content">-->
    <!--      <div class="nav-tex">-->
    <!--        <div class="name">您现在的位置：{{name}}</div>-->
    <!--        <div class="name">欢迎 <b>{{user.mnickname}}</b> ，使用社会组织专家智库系统！</div>-->
    <!--      </div>-->
    <!--      <div class="contents">-->
    <!--        <leftPage :active="active" :act="act"/>-->
    <!--        <div class="right-box">-->
    <!--          <router-view @setActive="getActive"></router-view>-->
    <!--        </div>-->
    <!--      </div>-->
    <!--    </div>-->
    <!--    <div class="foot-box">-->
    <!--      <footPage />-->
    <!--    </div>-->

    <div class="main-content">
      <div class="left-navbox" :class="{ active: !showMenus }">
        <div class="left-scroll scroll">
          <leftPage :active="active" />
        </div>
      </div>
      <div class="right-contentbox">
        <div class="hideBtn" @click="showMenus = !showMenus">
          <i class="iconfont icon-jiantouzuo" v-if="showMenus"></i>
          <i class="iconfont icon-jiantouyou" v-else></i>
        </div>
        <div class="head-content">
          <headPage />
        </div>
        <div class="content-wapper scroll">
          <router-view @setActive="getActive"></router-view>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import headPage from "./common/headPage";
import leftPage from "./common/leftPage";
// import footPage from './common/footPage'
// import { getInfo } from "@/api/login";
export default {
  name: "home",
  data() {
    return {
      active: 0,
      name: "",
      showMenus: true,
      detailDialogVisible: false,
      cur_nid: 0,
    };
  },
  computed: {
    user() {
      return this.$store.state.user;
    },
  },
  components: {
    headPage,
    leftPage,
    // footPage
  },
  created() {
    // this.getUpInfo()
  },
  methods: {
    // async getUpInfo() {
    //   let _data = await getInfo(this.user.type, this.user.mid);
    //   if (_data.data.id) {
    //     this.cur_nid = _data.data.id;
    //     this.detailDialogVisible = true;
    //   }
    // },

    getActive(data) {
      this.active = Number(data.active);
    },
  },
  watch: {},
  filters: {},
};
</script>

<style scoped lang="scss">
.home {
  width: 100%;
  height: 100vh;
  .main-content {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: flex-start;
    .left-navbox {
      width: 230px;
      height: 100%;
      background: #5298e2;
      //transition: 1s;
      //flex-shrink: 0;
      //transform: translateX(0px);
      display: block;

      overflow: hidden;
      .left-scroll {
        width: 240px;
        height: 100%;
        padding-right: 10px;
        overflow-y: auto;
      }
      &.active {
        display: none;
        transform: translateX(-230px);
      }
    }
    .right-contentbox {
      flex: 1;
      height: 100vh;
      position: relative;
      .hideBtn {
        width: 18px;
        height: 50px;
        border-top-right-radius: 5px;
        border-bottom-right-radius: 5px;
        text-align: center;
        line-height: 50px;
        cursor: pointer;
        position: absolute;
        left: 0;
        top: 50%;
        z-index: 1;
        margin-top: -25px;
        background: #2160a2;
        i {
          font-size: 14px;
          color: #ffffff;
        }
      }

      .head-content {
        width: 100%;
        height: 70px;
      }

      .content-wapper {
        padding: 0 30px;
        background: #f9f9f9;
        width: 100%;
        height: calc(100vh - 70px);
        overflow-y: auto;
        padding-bottom: 30px;
      }
    }
  }
}
</style>
